import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ff8132da")
const _hoisted_1 = { class: "justify-center mt-5 d-flex align-center width-full" }
const _hoisted_2 = { class: "align-center d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "px-2 ml-4 rounded-lg font-weight-black text-overline state text-grey"
}
const _hoisted_4 = { class: "button-group mr-5 d-flex" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("mdi-plus")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("mdi-minus")
_popScopeId()

import { withDefaults, computed } from 'vue'
import AutomationState from '@/lib/enums/AutomationState'
import { IAutomation } from '@/interfaces/hoppermation'

interface IProps {
  automation?: IAutomation
  zoom?: (direction: string) => void
  save?: () => void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    automation: { type: null, required: false, default: () => ({} as IAutomation) },
    zoom: { type: Function, required: false, default: () => ({}) },
    save: { type: Function, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { automation: IAutomation, zoom: (direction: string) => void, save: () => void }


const isDraft = computed((): boolean => {
  return props.automation.status === AutomationState.DRAFT
})

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { absolute: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_app_bar_title, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(props.automation.name) + " ", 1),
              (_unref(isDraft))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('automation.status.DRAFT')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            class: "square-button button-group-left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (props.zoom('in')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_6,
          _createVNode(_component_v_btn, {
            class: "square-button button-group-right",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (props.zoom('out')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (props.save()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('actions.save')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})